export const pathSuite = 'https://hookahapp.ru/';

export const MAIN_PATH = 'MAIN';
export const MIXER_PATH = 'MIXER';
export const FAVORITE_PATH = 'FAVORITE';

export const regExGroupCard = new RegExp("/main/list-compilation/[0-2]");
export const regExShareMix = new RegExp("#/main/shared-mix/[0-9]");



